module.exports = __webpack_public_path__ + "img/8.45a4e736.jpeg";